import { iso, Newtype } from "newtype-ts";
import React from "react";

type Feature = Newtype<{ readonly Feature: unique symbol }, boolean>;

export function fold<T>(
  f: Feature,
  ifDisabled: () => T,
  ifEnabled: () => T,
): T {
  return iso<Feature>().unwrap(f) ? ifEnabled() : ifDisabled();
}

export function whenEnabled<T>(f: Feature, ifEnabled: () => T): T | null {
  return fold(f, () => null, ifEnabled);
}

export function whenDisabled<T>(f: Feature, ifDisabled: () => T): T | null {
  return fold(f, ifDisabled, () => null);
}

export function isEnabled(f: Feature): boolean {
  return fold(
    f,
    () => false,
    () => true,
  );
}

export const enabled = iso<Feature>().wrap(true);
export const disabled = iso<Feature>().wrap(false);

export function useFeatures() {
  return React.useContext(Features);
}

const Features = React.createContext({
  market: {
    linkedOnHeader: disabled,
    daysOnMarket: disabled,
  },
  landingRent: {
    showPrice: disabled,
  },
  landingSearch: {
    linkedOnHeader: enabled,
  },
  landingSell: {
    valuationCta: enabled,
  },
  global: {
    showPhone: enabled,
  },
  header: {
    showPhone: enabled,
    showValuationButton: enabled,
  },
  stepper: {
    useOtpPhoneVerification: enabled,
  },
});

export const FeaturesProvider = Features.Provider;
